import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../../../utils';
import ServicesFactory from '../Services/ServicesFactory';
import { useConfig } from '../../../../../context';
const SuggestServices = ({ segmentId, services }) => {
    const theme = useTheme('ServiceAggregation').ServiceAggregation, suggestTheme = useTheme('Checkout').SuggestServices;
    const { Engine: { nas: { suggestServicesTypes } } } = useConfig();
    const { t } = useTranslation('ServiceAggregation');
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    let hideBlock = false;
    const filteredServices = React.useMemo(() => {
        const suggestServices = [];
        services.forEach(service => {
            if (service.type === 'insurance' ||
                service.type === 'insuranceGroups' ||
                (!isMobile && suggestServicesTypes.includes(service.type))) {
                suggestServices.push(service);
            }
        });
        return suggestServices;
    }, [segmentId, services, isMobile, suggestServicesTypes]);
    if (!filteredServices.length ||
        filteredServices.every(service => service.type !== 'insurance' &&
            service.type !== 'insuranceGroups' &&
            service.selectedServices.length > 0)) {
        hideBlock = true;
    }
    return (React.createElement("div", { className: cn(theme.container, { [suggestTheme.hidden]: hideBlock }) },
        React.createElement("div", { className: theme.header }, t('Add to your order')),
        React.createElement("div", { className: suggestTheme.services }, filteredServices.map(service => (React.createElement(ServicesFactory, { key: service.type, service: service, segmentId: segmentId, hideCard: service.selectedServices.length > 0 }))))));
};
export default SuggestServices;
